import { client } from './client';

// --- API Keys ---

export const getApiKeyAbilities = async () => {
    const response = await client.get('/v1/auth/api-keys/abilities');
    return response.data;
};

export const getApiKeys = async () => {
    const response = await client.get('/v1/auth/api-keys');
    return response.data?.items ?? response.data;
};

export const createApiKey = async (data) => {
    const response = await client.post('/v1/auth/api-keys', data);
    return response.data;
};

export const updateApiKey = async (id, data) => {
    const response = await client.put(`/v1/auth/api-keys/${id}`, data);
    return response.data;
};

export const deleteApiKey = async (id) => {
    await client.delete(`/v1/auth/api-keys/${id}`);
};
